<template>
    <v-row>
        <v-navigation-drawer width="350" height="100%" v-model="ShowFilter" absolute temporary>
            <v-col class="pa-7" cols="12">
                <v-row>
                    <h2>فیلترها</h2>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="ShowFilter = false" style="text-decoration:none">
                    </v-btn>
                </v-row>
            </v-col>
            <v-divider></v-divider>

            <v-col class="pa-0" cols="12">
                <v-col cols="12">
                    <v-col v-for="item in filters" :key="item.key" cols="12" class="mb-3">
                        <v-row v-if="item.type === 'StrSearch'">
                            <v-col cols="12">
                                <v-text-field dense placeholder=" " hide-details v-model="item.value" label="جستجو"
                                    outlined>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="item.type === 'singleDate'">
                            <v-col class="pb-0" cols="12">
                                <v-text-field dense :id="item.name" placeholder=" " hide-details
                                    v-model="item.value" :label="item.title" outlined>
                                </v-text-field>

                                <custom-date-picker display-format='jYYYY/jMM/jDD' type="date"
                                    :element="item.name" v-model="item.value">
                                </custom-date-picker>
                            </v-col>
                        </v-row>
                        <v-row v-if="item.type === 'string'">
                            <v-text-field v-model="item.value" :label="item.title" dense outlined hide-details>
                            </v-text-field>
                        </v-row>
                        <v-row v-if="item.type === 'date'">
                            <v-col class="pb-0" cols="12" sm="5">
                                <v-text-field dense :id="item.child.beginName" placeholder=" " hide-details
                                    v-model="item.child.beginValue" :label="item.child.beginTitle" outlined>
                                </v-text-field>

                                <custom-date-picker display-format='jYYYY/jMM/jDD' type="date"
                                    :element="item.child.beginName" v-model="item.child.beginValue">
                                </custom-date-picker>
                            </v-col>
                            <v-col class="pb-0" cols="12" sm="5">
                                <v-text-field dense placeholder=" " :id="item.child.endName" hide-details
                                    v-model="item.child.endValue" :label="item.child.endTitle" outlined>
                                </v-text-field>

                                <custom-date-picker type="date" :element="item.child.endName"
                                    v-model="item.child.endValue">
                                </custom-date-picker>
                            </v-col>
                            <v-col cols="12" sm="2" class="pa-0 pt-2 pl-1">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon large v-bind="attrs" v-on="on">
                                            <iconly name="calendar" type="bulk" color="orange" />
                                        </v-btn>
                                    </template>
                                    <v-list small dense hide-details>
                                        <v-list-item @click="SetPeriodDate(item, period.value)"
                                            v-for="period in periodList" :key="period.value">
                                            <v-list-item-title>
                                                {{period.text}}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <!-- <v-autocomplete placeholder=" " v-model="item.value" :items="periodList" item-value="id"
                                outlined dense :small-chips="item.multiple"></v-autocomplete> -->
                            </v-col>
                        </v-row>
                        <v-row v-if="item.type === 'status'">
                            <v-col class="pt-0 pr-0 pl-0 pb-0" cols="12">
                                <v-autocomplete placeholder=" " v-model="item.value" :items="statusItems" hide-details
                                    item-value="id" item-text="text" outlined dense :small-chips="item.multiple" :label="item.title"
                                    :multiple="item.multiple"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="item.type === 'dropdown'">
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-autocomplete placeholder=" " v-model="item.value" :items="item.options" hide-details
                                    item-value="id" outlined dense :small-chips="item.multiple" :label="item.title"
                                    :multiple="item.multiple"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="item.type === 'search'">
                            <v-col class="pt-0 pb-0" cols="12">
                                <tk-search :url="item.url" :label="item.title" v-model="item.value" />
                            </v-col>
                        </v-row>
                        <v-row v-if="item.type === 'bool'">
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-switch :label="item.title" v-model="item.value" />
                            </v-col>
                        </v-row>
                        <v-row v-if="item.type === 'slider'">
                            <span>اعتبار مشتری</span>
                            <v-range-slider v-model="item.value" persistent-hint :max="1000" :min="-1000"
                                :hint="'از ' + item.value[0] + ' میلیون تا ' + item.value[1] + ' میلیون  ریال'">
                                <template v-slot:thumb-label="props">
                                    {{ props.value }}
                                </template>
                            </v-range-slider>
                        </v-row>
                        <v-row v-if="item.type === 'number'">
                            <v-text-field :rules="[numberRule]" v-model="item.value" :label="item.title" outlined dense
                                hide-details>
                            </v-text-field>
                        </v-row>
                    </v-col>
                </v-col>
                <v-col class="mx-auto text-center" cols="12"
                    :style="[{position: 'absolute',bottom: '5px'}, {backgroundColor: $vuetify.theme.dark ? '#363636': 'white'}]">
                    <v-divider></v-divider>
                    <v-row class="mx-auto justify-center mt-3">
                        <v-btn @click.prevent="getData" depressed rounded class="white--text ml-2" width="100"
                            height="40" color="primary">
                            <h3>فیلتر کن</h3>
                        </v-btn>
                        <v-btn @click="Clear" color="grey" height="40" rounded outlined>حذف همه فیلتر ها</v-btn>
                    </v-row>
                </v-col>
            </v-col>

        </v-navigation-drawer>
    </v-row>
</template>

<script>
    var moment = require('jalali-moment');
    export default {
        name: 'MyFilter',
        components: {
            moment
        },
        data() {
            return {
                ShowFilter: false,
                periodList: [{
                        text: 'امروز',
                        value: 'today'
                    },
                    {
                        text: 'دیروز',
                        value: 'yesterday'
                    },
                    {
                        text: 'تا امروز',
                        value: 'toToday'
                    },
                    {
                        text: 'هفته جاری',
                        value: 'currWeek'
                    },
                    {
                        text: 'ماه جاری',
                        value: 'currMonth'
                    },
                    {
                        text: 'ماه قبل',
                        value: 'pastMonth'
                    },
                    {
                        text: 'سه ماه قبل',
                        value: 'thirdMonth'
                    },
                    {
                        text: 'امسال',
                        value: 'currYear'
                    },
                    {
                        text: 'پارسال',
                        value: 'pastYear'
                    },
                    {
                        text: 'بدون محدودیت',
                        value: 'none'
                    },
                ],
                filters: [],
                statusItems:[]
            }
        },
        mounted() {
            this.filters = this.$store.state.filters;
            // if(this.filters.filter(x=>x.type== 'status').length > 0){
            //     this.getStatus()
            // }
            // this.getStatus()
        },
        methods: {
            getData() {
                this.ShowFilter = false;
                this.$emit('getData', true);
            },
            Clear() {
                this.ShowFilter = false;
                this.ClearFilter(this.filters);
                this.getData();
            },
            SetPeriodDate(item, type) {
                moment.locale('fa');
                switch (type) {
                    case "today": {
                        var today = moment().format('YYYY/MM/DD');
                        item.child.beginValue = today;
                        item.child.endValue = today;
                        break;
                    }
                    case "yesterday": {
                        var yesterday = moment().add(-1, 'day').format('YYYY/MM/DD');
                        item.child.beginValue = yesterday;
                        item.child.endValue = yesterday;
                        break;
                    }
                    case "toToday": {
                        item.child.beginValue = '';
                        item.child.endValue = moment().format('YYYY/MM/DD');
                        break;
                    }
                    case "currWeek": {
                        item.child.beginValue = moment().startOf('week').format('YYYY/MM/DD');
                        item.child.endValue = moment().endOf('week').format('YYYY/MM/DD');
                        break;
                    }
                    case "currMonth": {
                        item.child.beginValue = moment().startOf('month').format('YYYY/MM/DD');
                        item.child.endValue = moment().endOf('month').format('YYYY/MM/DD');
                        break;
                    }
                    case "pastMonth": {
                        item.child.beginValue = moment().add(-1, 'month').startOf('month').format('YYYY/MM/DD');
                        item.child.endValue = moment().add(-1, 'month').endOf('month').format('YYYY/MM/DD');
                        break;
                    }
                    case "thirdMonth": {
                        item.child.beginValue = moment().add(-3, 'month').startOf('month').format('YYYY/MM/DD');
                        item.child.endValue = moment().add(-1, 'month').endOf('month').format('YYYY/MM/DD');
                        break;
                    }
                    case "currYear": {
                        item.child.beginValue = moment().startOf('year').format('YYYY/MM/DD');
                        item.child.endValue = moment().endOf('year').format('YYYY/MM/DD');
                        break;
                    }
                    case "pastYear": {
                        item.child.beginValue = moment().add(-1, 'year').startOf('year').format('YYYY/MM/DD');
                        item.child.endValue = moment().add(-1, 'year').endOf('year').format('YYYY/MM/DD');
                        break;
                    }
                    default: {
                        item.child.beginValue = '';
                        item.child.endValue = '';
                        break;
                    }
                }
                moment.locale('en');
            },
        }
    }
</script>

<style>
    .v-overlay--absolute {
        position: fixed !important;
    }

    .v-navigation-drawer {
        position: fixed !important;
    }
</style>
